import React from 'react';

import { IBodyCopyFields } from '@/types/contentful';

import { SpacingToken } from '../../theme/tokens/spacing';
import { ResponsiveTokenSet, TokenProp } from '../../theme/tokens/types';
import { ColumnSize } from '../Layout/styles';

import RichText from '../RichText';
import { BlockContainer, Layout, Column } from '../Layout';

interface BodyCopyProps extends IBodyCopyFields {
  sizeOverride?: TokenProp<ColumnSize>;
  xPaddingOverrides?: ResponsiveTokenSet<SpacingToken>;
  yMarginTopOverride?: ResponsiveTokenSet<SpacingToken>;
  yMarginBottomOverride?: ResponsiveTokenSet<SpacingToken>;
}

export function BodyCopy({
  sectionId,
  copy,
  sizeOverride,
  xPaddingOverrides,
  yMarginTopOverride,
  yMarginBottomOverride
}: BodyCopyProps) {
  return (
    <BlockContainer
      id={sectionId}
      xPaddingOverrides={xPaddingOverrides}
      marginTop={
        yMarginTopOverride ?? {
          0: 'blockMarginY',
          tablet: 'blockMarginY_tablet'
        }
      }
      marginBottom={
        yMarginBottomOverride ?? {
          0: 'blockMarginY',
          tablet: 'blockMarginY_tablet'
        }
      }
      data-blockid="bodyCopy"
      data-testid="bodyCopy"
    >
      <Layout>
        <Column
          size={sizeOverride ?? { 0: 11, tablet: 8 }}
          flexDirection="column"
        >
          <RichText data={copy} />
        </Column>
      </Layout>
    </BlockContainer>
  );
}
